import React from "react";
import { Button } from "antd";

function FirstStepButtons(props) {
  return (
    <React.Fragment>
      {props.showSkip && (
        <div className="button-wrapper">
          <span className="fake-link" onClick={props.handleSkipClick}>
            Skip for now
          </span>
        </div>
      )}

      <div className="button-wrapper next-button">
        <Button className="next-btn right" type="primary" loading={props.isLoading} onClick={props.handleNextClick}>
          Next
        </Button>
      </div>
    </React.Fragment>
  );
}

export default FirstStepButtons;
